export default "__VITE_ASSET__8768b82a__"